export default __webpack_public_path__ + "static/media/Frame 10825.ca4e6caa.svg";